// extracted by mini-css-extract-plugin
module.exports = {"inputPhoneNumber":"_38LLbHtuX933wZQVlGN2OU","code":"_3R7ab6tblHAX-TevDskt1t","number":"_1gzgtQB2zSPeYHMeh78swr"};